var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-stock"},[_c('button',{staticClass:"btn btn-sm btn-outline-secondary",on:{"click":_vm.stock}},[_vm._v("Re-lancer le stock")])])
}
var staticRenderFns = []

export { render, staticRenderFns }